import { CoreFieldProps, CurrencyFieldProps, fieldTypes, NumericFieldProps, SectionHeader } from "@ucl/library";
import { FC } from "react";
import { FieldComplexV2 } from "./FieldComplexV2";
import "./ComplexFields.scss";
import { COMPLEX_FIELD_KEYS } from "@/constants/fieldKeys";
import { DepositApplicationReadDTO } from "@/types";

export interface WiresOptInComplexValue {
  showHeader?: boolean;
  headerLabel?: string;
  readOnly?: boolean;
}

export interface WiresOptInComplexFieldProps extends fieldTypes.BaseFieldProps<any> {
  formValue?: DepositApplicationReadDTO;
}

export const WiresOptInComplexField: FC<WiresOptInComplexFieldProps> = (props) => {
  const wiresOptInComplexValue = props.complexFieldValue as WiresOptInComplexValue;
  const readOnly = wiresOptInComplexValue?.readOnly || props.readOnly;

  return (
    <section className="complex-field-container wires-opt-in">
      <SectionHeader label={wiresOptInComplexValue?.headerLabel || props.label} hidden={!wiresOptInComplexValue?.showHeader} />
      <div className="complex-field-content">
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.WIRES_OPT_IN.IS_WIRES_OPT_IN_ENABLED}
          complexFieldProps={{
            disabled: readOnly,
          }}
        />
        {/* Wire conditional fields - show when enabled */}
        {props.formValue?.wiresOptIn?.isWiresOptInEnabled && (
          <div className="opt-ins-form-v2__wire-fields">
            <FieldComplexV2
              {...props}
              complexFieldKey={COMPLEX_FIELD_KEYS.WIRES_OPT_IN.WIRE_TYPE_AS_LIST}
              complexFieldProps={{
                disabled: readOnly,
              } as Partial<CoreFieldProps>}
            />
            <FieldComplexV2
              {...props}
              complexFieldKey={
                COMPLEX_FIELD_KEYS.WIRES_OPT_IN.ESTIMATED_QUANTITY_OF_WIRES_PER_MONTH
              }
              complexFieldProps={{
                disabled: readOnly,
                showIncrementButtons: false,
                format: "n0"
              } as NumericFieldProps}
            />
            <FieldComplexV2
              {...props}
              complexFieldKey={COMPLEX_FIELD_KEYS.WIRES_OPT_IN.AVERAGE_DOLLAR_AMOUNT_PER_WIRE}
              complexFieldProps={{
                disabled: readOnly,
                showIncrementButtons: false
              } as CurrencyFieldProps}
            />
            <FieldComplexV2
              {...props}
              complexFieldKey={
                COMPLEX_FIELD_KEYS.WIRES_OPT_IN.ESTIMATED_TOTAL_WIRE_DOLLAR_AMOUNT_PER_MONTH
              }
              complexFieldProps={{
                disabled: readOnly,
                showIncrementButtons: false
              } as CurrencyFieldProps}
            />
          </div>
        )}
      </div>
    </section>
  );
};
